import React from 'react'
import "./SearchContainer.css"
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux';
function SearchContainer({ searchkey, products, categories }) {
  const { currentLocal } = useSelector((state) => state.currentLocal);

  return (
    <div className='mt-4 search_container'>
      <Container fluid>
        <Row>

          {products?.length !== 0 &&
            <Col md={12}>
              <h6>{currentLocal.home.products}</h6>
              {products && products?.map((item, index) => {

                return (
                  <Link className='d-flex align-items-center mt-2' key={index} to={`/product/${item.id}`}>
                    <img src={item?.images[0]?.image} alt="" className="w-25 me-1" />

                    <div>                     
                       <p className='mb-0'>{currentLocal.language=="English"?item?.name_en:item?.name_ar}</p>

                      {item && item?.discounted_price_egp != 0 ?

                        <div className='d-flex align-items-center'>
                          <p className='mb-0 price text-decoration-line-through'>EGP {Number(item && item?.price_egp).toFixed(2)}</p>
                          <p className='mb-0 price mx-2'>EGP {Number(item && item.discounted_price_egp).toFixed(2)}</p>
                        </div> 
                        :

                        <p className='mb-0 price_discount'>EGP {Number(item && item.price_egp).toFixed(2)} </p>

                      }

                    </div>            
                          </Link>

                )
              })}


            </Col>
          }
        </Row>
      </Container>

    </div>
  )
}

export default SearchContainer